import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, ReactReduxContext, Provider } from 'react-redux';
import * as _ from 'lodash';
import { editProductId } from 'redux/modules/newAffiliate';
import { toggleOrgBillingVisibility } from 'redux/modules/teamManagement';
import { getContractData } from 'redux/modules/contract';
import { cancelClient, changeAdsPlan, clearStripeError, depositAdsFunds, getAdSpendSummaryForOrganization, getBillingHistory, sendCancellationEmail, sendOneTimeAdChargeEmail, sendBudgetChangeEmail, showStripeError, setAdsPaymentMethod, updatePartnerClientBilling } from 'redux/modules/billing';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { AgreementPreview, Spinner } from 'components';
import moment from 'moment';
import ChangeProduct from './ChangeProduct';
import EditPlan from './EditPlan';
import * as styles from './BillingDetail.scss';
import { changeField } from 'redux/modules/forms';
var BillingDetail = (_dec = connect(function (state) {
  return {
    billingHistory: state.billing.billingHistory,
    config: state.config,
    formValues: state.newClient,
    editFormValues: state.forms.client_edit_billing,
    addFundsInProgress: state.billing.addFundsInProgress,
    billingError: state.billing.billingError,
    changingAdsPlan: state.billing.changingAdsPlan,
    step1Valid: state.forms.client_edit_billing && state.forms.client_edit_billing.validation && state.forms.client_edit_billing.validation.step1Valid,
    sendingEditForm: state.forms.client_edit_billing && state.forms.client_edit_billing.sendingForm,
    editStep: state.forms.client_edit_billing ? state.forms.client_edit_billing.step : 0,
    organization: state.organization.current,
    orgBillingVisible: state.teamManagement.orgBillingVisible,
    partnerDetails: state.teamManagement.partnerDetails,
    togglingOrgBillingVisibility: state.teamManagement.togglingOrgBillingVisibility,
    contract: state.contract || null,
    gettingContract: state.contract.gettingContract,
    theme: state.theme,
    selectedProduct: state.newAffiliate.affiliateConfig && state.newAffiliate.affiliateConfig.affiliateProductId ? state.newAffiliate.affiliateConfig.affiliateProductId : null,
    editingProductId: state.newAffiliate.editingProductId
  };
}, {
  cancelClient: cancelClient,
  changeAdsPlan: changeAdsPlan,
  editProductId: editProductId,
  clearStripeError: clearStripeError,
  depositAdsFunds: depositAdsFunds,
  getAdSpendSummaryForOrganization: getAdSpendSummaryForOrganization,
  getBillingHistory: getBillingHistory,
  getContractData: getContractData,
  sendBudgetChangeEmail: sendBudgetChangeEmail,
  sendCancellationEmail: sendCancellationEmail,
  sendOneTimeAdChargeEmail: sendOneTimeAdChargeEmail,
  setAdsPaymentMethod: setAdsPaymentMethod,
  showStripeError: showStripeError,
  toggleOrgBillingVisibility: toggleOrgBillingVisibility,
  changeField: changeField,
  updatePartnerClientBilling: updatePartnerClientBilling
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(BillingDetail, _Component);

  var _super = _createSuper(BillingDetail);

  function BillingDetail(props) {
    var _this2;

    _classCallCheck(this, BillingDetail);

    _this2 = _super.call(this, props); // So testing can get past this (`Stripe` will not be in scope in Jest because it is loaded from a linked JS file)

    _defineProperty(_assertThisInitialized(_this2), "formatCurrency", new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format);

    _defineProperty(_assertThisInitialized(_this2), "generateErrorText", function (fieldName) {
      var errorText = '';
      return errorText;
    });

    _defineProperty(_assertThisInitialized(_this2), "handleUpdateCC", function () {
      var _this = _assertThisInitialized(_this2);

      var stripePaymentObject = Stripe.card;

      _this2.setState({
        settingAdsPaymentMethod: true
      });

      return new Promise(function (resolve, reject) {
        stripePaymentObject.createToken({
          number: _this2.state.cardNumber,
          exp_month: _this2.state.expMonth,
          exp_year: _this2.state.expYear,
          cvc: _this2.state.cvc
        }, function (status, response) {
          if (response.error) {
            _this2.setState({
              settingAdsPaymentMethod: false
            });

            return _this2.props.showStripeError(response.error);
          }

          if (status === 200) {
            _this2.props.clearStripeError();

            _this2.props.setAdsPaymentMethod({
              paymentSourceId: response.id,
              cardNumber: _this2.state.cardNumber,
              exp_month: _this2.state.exp_month,
              exp_year: _this2.state.exp_year,
              cvc: _this2.state.cvc
            }, _this2.props.clientDetails.organization_id, _this2.props.cc).then(function () {
              _this2.setState({
                settingAdsPaymentMethod: false,
                showCCModal: false
              });

              _this2.props.closeParentModal('Credit card updated');
            });
          }

          console.log(status, response);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "handleCardFieldChange", function (e) {
      _this2.setState(_defineProperty({}, e.target.id, e.target.value));
    });

    _defineProperty(_assertThisInitialized(_this2), "handleCancel", function () {
      if (window.confirm('Please confirm that you want to end this subscription.')) {
        _this2.setState({
          cancelingSubscription: true
        });

        _this2.props.cancelClient(_this2.props.partnerDetails.contract.OrganizationId, _this2.props.clientDetails.organization_id).then(function (cancelledClient) {
          if (_this2.props.partnerDetails.contract.OrganizationId !== 0) {
            _this2.props.sendCancellationEmail(cancelledClient, _this2.props.partnerDetails, _this2.props.orgBillingConfig).then(function () {
              _this2.setState({
                cancelingSubscription: false,
                showCancelModal: false
              });

              location.reload();
            });
          } else {
            _this2.setState({
              cancelingSubscription: false,
              showCancelModal: false
            });

            location.reload();
          }
        })["catch"](function () {
          _this2.setState({
            cancelingSubscription: false,
            showCancelModal: false
          });

          location.reload();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "handleChangeProduct", function () {
      if (window.confirm('Are you sure you want to change the product for this client? This will change the amount they are billed on their next invoice.')) {
        _this2.props.editProductId(_this2.props.clientDetails.organization_id, _this2.props.selectedProduct).then(function (res) {
          window.location.reload();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "handleChangePlan", function (amt) {
      var orgBillingType = _this2.props.clientDetails.organizationBillingConfig_BillingType;

      if (['ads_only', 'end_to_end'].includes(orgBillingType)) {
        _this2.props.changeField('client_edit_billing', 'sendingForm', true);

        console.log('partner terms', _this2.props.partnerDetails.terms);
        console.log('use new billing change for ads only / end2end');
        console.log('orgBillingConfig', _this2.props.editFormValues.orgConfig);
        var _this2$props$editForm = _this2.props.editFormValues.orgConfig,
            adsBudget = _this2$props$editForm.adsBudget,
            clientFee = _this2$props$editForm.managementFee,
            managementMethod = _this2$props$editForm.managementMethod,
            adsCommissionPercent = _this2$props$editForm.adsCommissionPercent;
        return _this2.props.updatePartnerClientBilling(_this2.props.clientDetails.organization_id, _objectSpread(_objectSpread({
          adsCommissionPercent: adsCommissionPercent,
          adsBudget: adsBudget
        }, orgBillingType === 'ads_only' ? {} : {
          clientFee: clientFee
        }), {}, {
          managementMethod: managementMethod
        }, managementMethod ? {
          likeableLicenseFee: managementMethod === 'partnerManaged' ? _this2.props.partnerDetails.terms.partnerManagedMonthlyFee : _this2.props.partnerDetails.terms.llManagedMonthlyFee
        } : {})).then( /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
            var clientBillingConfig, data;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    clientBillingConfig = _ref.clientBillingConfig;
                    data = {
                      oldAdsCommissionPercent: _this2.props.orgBillingConfig.adsCommissionPercent,
                      newAdsCommissi: adsCommissionPercent,
                      oldAdsBudget: _this2.props.orgBillingConfig.adsBudget,
                      newAdsBudget: clientBillingConfig.AdsBudget,
                      clientName: _this2.props.clientDetails.organization_name,
                      clientOrgId: _this2.props.clientDetails.organization_id,
                      partnerName: _this2.props.partnerDetails.contract.businessName,
                      partnerOrgId: _this2.props.partnerDetails.contract.id
                    };
                    _context.next = 4;
                    return Promise.all([_this2.props.getBillingHistory(_this2.props.clientDetails.organization_id), _this2.props.getAdSpendSummaryForOrganization(_this2.props.clientDetails.organization_id), _this2.props.partnerDetails.contract.OrganizationId !== 0 ? _this2.props.sendBudgetChangeEmail(data) : Promise.resolve()]);

                  case 4:
                    window.location.reload();

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }());
      }

      var newAmount = amt === null || amt === undefined ? _this2.props.editFormValues.orgConfig.adsBudget : amt;
      var orgId = _this2.props.clientDetails.organization_id;
      var hasPlan = _this2.props.billingHistory.findIndex(function (e) {
        return !!e.lineItems.length;
      }) !== -1;
      var oldAdsBudget = _this2.props.orgBillingConfig.adsBudget;
      return _this2.props.changeAdsPlan(_this2.props.clientDetails.organization_id, newAmount, _this2.props.editFormValues.orgConfig.adsCommissionPercent).then(function (res) {
        var data = {
          oldAdsBudget: oldAdsBudget,
          newAdsBudget: res.data.AdsBudget,
          clientName: _this2.props.clientDetails.organization_name,
          clientOrgId: _this2.props.clientDetails.organization_id,
          partnerName: _this2.props.partnerDetails.contract.businessName,
          partnerOrgId: _this2.props.partnerDetails.contract.id
        };

        if (_this2.props.partnerDetails.contract.OrganizationId !== 0) {
          _this2.props.sendBudgetChangeEmail(data);
        }

        _this2.setState({
          showPlanModal: false,
          showLicenseAdsCancelModal: false
        });

        _this2.props.closeParentModal('Ads plan changed');

        return Promise.all([_this2.props.getBillingHistory(orgId), _this2.props.getAdSpendSummaryForOrganization(orgId)]);
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "handleAddFunds", function () {
      var orgId = _this2.props.clientDetails.organization_id;
      var paymentSourceToken = _this2.props.cc.id;

      _this2.props.depositAdsFunds(_this2.state.addFundsModalAmount, paymentSourceToken, orgId).then(function (res) {
        if (_this2.props.partnerDetails.contract.OrganizationId !== 0) {
          _this2.props.sendOneTimeAdChargeEmail(_this2.props.clientDetails.organization_name, res.data.charge.amount, _this2.props.partnerDetails);
        }

        _this2.setState({
          showAddFundsModal: false
        });

        _this2.props.closeParentModal('Ad funds added');

        return Promise.all([_this2.props.getBillingHistory(orgId), _this2.props.getAdSpendSummaryForOrganization(orgId)]);
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "toggleOrgBillingVisibility", function () {
      _this2.props.toggleOrgBillingVisibility(_this2.props.clientDetails.organization_id, !_this2.props.orgBillingVisible);
    });

    global.Stripe || global.window && global.window.Stripe ? Stripe.setPublishableKey(props.config.stripePublicKey) : null;
    _this2.state = {
      addFundsModalAmount: 50,
      addingFunds: false,
      editPlanStep: 1,
      showAgreementModal: false,
      showAddFundsModal: false,
      showCCModal: false,
      showPlanModal: false,
      showCancelModal: false,
      cancelingSubscription: false,
      settingAdsPaymentMethod: false,
      cardNumber: '',
      exp_month: '',
      exp_year: '',
      cvc: ''
    };
    return _this2;
  }
  /** *******************************************************************************************
  CUSTOM METHODS
  ********************************************************************************************/


  _createClass(BillingDetail, [{
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this3 = this;

      var _this$props = this.props,
          orgBillingConfig = _this$props.orgBillingConfig,
          cc = _this$props.cc,
          partnerDetails = _this$props.partnerDetails,
          clientDetails = _this$props.clientDetails;
      var cancelled = clientDetails.organization_status === 'pending_cancel' || clientDetails.organization_status === 'cancelled';
      var hasPlan = this.props.billingHistory.findIndex(function (e) {
        return !!e.lineItems.length;
      }) !== -1;
      var ccModalActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          _this3.setState({
            showCCModal: false
          });
        },
        style: {
          marginRight: 24
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: this.state.settingAdsPaymentMethod ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spinner fa-spin",
          style: {
            fontSize: 20
          }
        }) : cc ? 'Update Card' : 'Add Card',
        onClick: this.handleUpdateCC,
        disabled: this.state.settingAdsPaymentMethod
      })];
      var addFundsModalActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        disabled: this.props.addFundsInProgress,
        onClick: function onClick() {
          _this3.setState({
            showAddFundsModal: false
          });
        },
        style: {
          marginRight: 24
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: this.props.addFundsInProgress ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spinner fa-spin",
          style: {
            fontSize: 20
          }
        }) : 'Add Funds',
        disabled: this.props.addFundsInProgress,
        onClick: this.handleAddFunds
      })];
      var cancelModalActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          _this3.setState({
            showCancelModal: false
          });
        },
        style: {
          marginRight: 24
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        backgroundColor: this.props.theme.colors.warningColor,
        labelColor: "white",
        label: this.state.cancelingSubscription ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spinner fa-spin",
          style: {
            fontSize: 20
          }
        }) : orgBillingConfig.billingMethod === 'affiliate' || orgBillingConfig.billingMethod === 'license' ? 'Cancel Client' : 'End Subscription',
        onClick: this.handleCancel,
        disabled: this.state.cancelingSubscription
      })];
      var cancelLicenseAdsModalActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          _this3.setState({
            showLicenseAdsCancelModal: false
          });
        },
        style: {
          marginRight: 24
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        backgroundColor: this.props.theme.colors.warningColor,
        labelColor: "white",
        label: this.props.changingAdsPlan ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spinner fa-spin",
          style: {
            fontSize: 20
          }
        }) : 'End Subscription',
        onClick: function onClick() {
          _this3.handleChangePlan(0);
        },
        disabled: this.props.sendingEditForm || this.props.changingAdsPlan
      })];
      var affiliateModalActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          _this3.setState({
            editPlanStep: 1,
            showPlanModal: false
          });
        },
        style: {
          marginRight: 24
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        disabled: this.props.editingProductId,
        label: this.props.editingProductId ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spinner fa-spin",
          style: {
            fontSize: 20
          }
        }) : 'Change Product',
        onClick: this.handleChangeProduct,
        style: {
          marginRight: 24
        }
      })];
      var planModalActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Close",
        onClick: function onClick() {
          _this3.setState({
            editPlanStep: 1,
            showPlanModal: false
          });
        },
        style: {
          marginRight: 24
        },
        disabled: this.props.changingAdsPlan
      })];

      if (this.props.editStep === 1) {
        if (cc) {
          planModalActions.push( /*#__PURE__*/React.createElement(RaisedButton, {
            key: "edit_next",
            secondary: true,
            label: "Next",
            disabled: !this.props.step1Valid,
            onClick: function onClick() {
              _this3.props.changeField('client_edit_billing', 'step', 2);
            }
          }));
        }

        if (hasPlan) {
          planModalActions.push( /*#__PURE__*/React.createElement(RaisedButton, {
            key: "edit_endsub",
            label: "End Subscription",
            onClick: function onClick() {
              _this3.setState({
                showPlanModal: false,
                showCancelModal: orgBillingConfig.billingMethod !== 'license',
                showLicenseAdsCancelModal: orgBillingConfig.billingMethod === 'license'
              });
            },
            style: {
              "float": 'left',
              marginLeft: 5
            }
          }));
        }

        if (orgBillingConfig.billingMethod === 'license') {
          planModalActions.push( /*#__PURE__*/React.createElement(RaisedButton, {
            key: "edit_cancel",
            label: "Cancel Client",
            onClick: function onClick() {
              _this3.setState({
                showPlanModal: false,
                showCancelModal: true
              });
            },
            style: {
              "float": 'left',
              marginLeft: 5
            }
          }));
        }
      }

      if (this.props.editStep === 2) {
        planModalActions.push( /*#__PURE__*/React.createElement(RaisedButton, {
          key: "edit_back",
          label: "Back",
          onClick: function onClick() {
            _this3.props.changeField('client_edit_billing', 'step', 1);
          },
          style: {
            marginRight: 24
          },
          disabled: this.props.sendingEditForm || this.props.changingAdsPlan
        }), /*#__PURE__*/React.createElement(RaisedButton, {
          key: "edit_submit",
          secondary: true,
          label: this.props.sendingEditForm || this.props.changingAdsPlan ? /*#__PURE__*/React.createElement("i", {
            className: "fa fa-spinner fa-spin",
            style: {
              fontSize: 20
            }
          }) : 'Submit',
          disabled: this.props.sendingEditForm || this.props.changingAdsPlan,
          onClick: function onClick() {
            return _this3.handleChangePlan();
          }
        }));
      }

      return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement("div", {
          className: styles.wrap,
          id: "BillingDetail"
        }, /*#__PURE__*/React.createElement("section", {
          className: styles.section
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.sectionTitle
        }, "Payment Method"), cc ? /*#__PURE__*/React.createElement("div", {
          className: styles.sectionContent
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.contentLine
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-cc-".concat(cc.brand.toLowerCase()),
          style: {
            fontSize: 20
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: styles.contentLine
        }, cc.brand, " Ending in ", cc.last4), /*#__PURE__*/React.createElement("div", {
          className: styles.contentLine
        }, "Expires ", cc.exp_month, "/", cc.exp_year)) : /*#__PURE__*/React.createElement("div", {
          className: styles.sectionContent
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.contentLine
        }, "No Payment Method")), /*#__PURE__*/React.createElement("div", {
          className: styles.sectionLinks
        }, cc ? /*#__PURE__*/React.createElement("span", {
          className: styles.link,
          onClick: function onClick() {
            _this3.setState({
              showCCModal: true
            });
          }
        }, "Update Payment Info") : /*#__PURE__*/React.createElement("span", {
          className: styles.link,
          onClick: function onClick() {
            _this3.setState({
              showCCModal: true
            });
          }
        }, "Add Credit Card"))), orgBillingConfig.billingMethod === 'affiliate' && /*#__PURE__*/React.createElement("section", {
          className: styles.section
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.sectionTitle
        }, "Product Details"), /*#__PURE__*/React.createElement("div", {
          className: styles.sectionContent
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.contentLine
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.contentLineTitle
        }, "Product Title:"), ' ', clientDetails.product_title), /*#__PURE__*/React.createElement("div", {
          className: styles.contentLine
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.contentLineTitle
        }, "Monthly Price:"), ' ', _this3.formatCurrency(clientDetails.contractProduct_monthlyFee)), /*#__PURE__*/React.createElement("div", {
          className: styles.contentLine
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.contentLineTitle
        }, "Monthly Ads Budget:"), ' ', _this3.formatCurrency(clientDetails.contractProduct_monthlyAdsBudget))), /*#__PURE__*/React.createElement("div", {
          className: styles.sectionLinks
        }, cc && !cancelled && /*#__PURE__*/React.createElement("span", {
          className: styles.link,
          onClick: function onClick() {
            _this3.setState({
              showPlanModal: true
            });
          }
        }, "Change Product"), cc && /*#__PURE__*/React.createElement("span", {
          className: styles.link,
          onClick: function onClick() {
            _this3.setState({
              showAddFundsModal: true
            });
          }
        }, "Add Advertising Funds"))), orgBillingConfig.billingMethod !== 'affiliate' && /*#__PURE__*/React.createElement("section", {
          className: styles.section
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.sectionTitle
        }, "Plan Details"), /*#__PURE__*/React.createElement("div", {
          className: styles.sectionContent
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.contentLine
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.contentLineTitle
        }, "Type:"), ' ', orgBillingConfig && orgBillingConfig.billingMethod && _.startCase(orgBillingConfig.billingMethod)), orgBillingConfig && orgBillingConfig.billingMethod && !['likeable_smb', 'license', 'likeable_partner'].includes(orgBillingConfig.billingMethod) && /*#__PURE__*/React.createElement("div", {
          className: styles.contentLine
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.contentLineTitle
        }, "Managed By:"), ' ', orgBillingConfig.managementMethod === 'partnerManaged' ? partnerDetails.contract.businessName : 'Likeable Local', ' ', "- $", orgBillingConfig.managementMethod === 'partnerManaged' ? partnerDetails.terms.partnerManagedMonthlyFee : partnerDetails.terms.llManagedMonthlyFee, "/mo"), _this3.props.orgBillingConfig && _this3.props.orgBillingConfig.billingMethod === 'end_to_end' && /*#__PURE__*/React.createElement("div", {
          className: styles.contentLine
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.contentLineTitle
        }, "Management Fee:"), ' ', "$", _this3.props.orgBillingConfig.managementFee, "/mo"), /*#__PURE__*/React.createElement("div", {
          className: styles.contentLine
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.contentLineTitle
        }, "Ads Budget:"), ' ', "$", orgBillingConfig && orgBillingConfig.adsBudget ? orgBillingConfig.adsBudget : '0', "/mo")), orgBillingConfig.billingMethod !== 'location' && /*#__PURE__*/React.createElement("div", {
          className: styles.sectionLinks
        }, !cancelled && orgBillingConfig.billingMethod !== 'likeable_partner' && /*#__PURE__*/React.createElement("span", {
          className: styles.link,
          onClick: function onClick() {
            _this3.setState({
              showPlanModal: true
            });
          }
        }, "Change Plan"), cc && /*#__PURE__*/React.createElement("span", {
          className: styles.link,
          onClick: function onClick() {
            _this3.setState({
              showAddFundsModal: true
            });
          }
        }, "Add Advertising Funds"))), orgBillingConfig.billingMethod !== 'likeable_partner' && /*#__PURE__*/React.createElement("section", {
          className: styles.section
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.sectionTitle
        }, "Settings"), /*#__PURE__*/React.createElement("div", {
          className: styles.sectionContent
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.contentLine
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.contentLineTitle
        }, !_this3.props.togglingOrgBillingVisibility && /*#__PURE__*/React.createElement("span", null, _this3.props.orgBillingVisible ? 'Billing History Visible To Client' : 'Billing History Hidden From Client'), _this3.props.togglingOrgBillingVisibility && /*#__PURE__*/React.createElement(Spinner, null)))), /*#__PURE__*/React.createElement("div", {
          className: styles.sectionLinks
        }, !_this3.props.togglingOrgBillingVisibility && /*#__PURE__*/React.createElement("span", {
          className: styles.link,
          onClick: _this3.toggleOrgBillingVisibility
        }, _this3.props.orgBillingVisible ? 'Make Hidden' : 'Make Visible'))), orgBillingConfig.billingMethod === 'affiliate' && /*#__PURE__*/React.createElement("section", {
          className: styles.section
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.sectionTitle
        }, "Agreement"), /*#__PURE__*/React.createElement("div", {
          className: styles.sectionContent
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.contentLine
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.contentLineTitle
        }, "Signed", ' ', moment(_this3.props.clientDetails.contract_signedAt).format('MM/DD/YYYY'), ' ', "by ", _this3.props.clientDetails.contract_firstName, ' ', _this3.props.clientDetails.contract_lastName))), /*#__PURE__*/React.createElement("div", {
          className: styles.sectionLinks
        }, !_this3.props.togglingOrgBillingVisibility && /*#__PURE__*/React.createElement("span", {
          className: styles.link,
          onClick: function onClick() {
            if (!_this3.props.gettingContract) {
              _this3.props.getContractData(_this3.props.clientDetails.contract_uuid).then(function () {
                _this3.setState({
                  showAgreementModal: true
                });
              });
            }
          }
        }, _this3.props.gettingContract ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spinner fa-spin",
          style: {
            fontSize: 20
          }
        }) : 'View Agreement'))), /*#__PURE__*/React.createElement(Dialog, {
          title: cc ? 'Edit Credit Card' : 'Add Credit Card',
          autoScrollBodyContent: true,
          open: _this3.state.showCCModal,
          onRequestClose: function onRequestClose() {
            _this3.setState({
              showCCModal: !_this3.state.showCCModal
            });
          },
          actions: ccModalActions,
          actionsContainerStyle: {
            padding: 12
          },
          titleStyle: {
            color: _this3.props.theme.colors.black2
          },
          overlayStyle: {
            backgroundColor: 'transparent'
          }
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'flex',
            flexWrap: 'wrap',
            paddingTop: 10,
            paddingBottom: 160
          }
        }, _this3.props.stripeError && _this3.props.stripeError !== '' && /*#__PURE__*/React.createElement("div", {
          className: styles.errorBox
        }, /*#__PURE__*/React.createElement("h2", {
          className: styles.stripeError
        }, _this3.props.stripeError)), /*#__PURE__*/React.createElement(TextField, {
          id: "cardNumber",
          "data-private": "lipsum",
          errorText: _this3.generateErrorText('cardNumber'),
          hintText: "Card Number*",
          floatingLabelText: "Card Number*",
          value: _this3.state.cardNumber,
          onChange: _this3.handleCardFieldChange,
          style: {
            marginRight: 8,
            marginLeft: 8,
            flex: '1 1 100%',
            width: 'auto'
          }
        }), /*#__PURE__*/React.createElement(TextField, {
          id: "expMonth",
          "data-private": "lipsum",
          errorText: _this3.generateErrorText('expMonth'),
          hintText: "Exp. Month (MM)*",
          floatingLabelText: "Exp. Month (MM)*",
          value: _this3.state.expMonth,
          onChange: _this3.handleCardFieldChange,
          style: {
            marginRight: 8,
            marginLeft: 8,
            flex: '1',
            minWidth: 155,
            width: 'auto'
          }
        }), /*#__PURE__*/React.createElement(TextField, {
          id: "expYear",
          "data-private": "lipsum",
          errorText: _this3.generateErrorText('expYear'),
          hintText: "Exp. Year (YY)*",
          floatingLabelText: "Exp. Year (YY)*",
          value: _this3.state.expYear,
          onChange: _this3.handleCardFieldChange,
          style: {
            marginRight: 8,
            marginLeft: 8,
            flex: '1',
            minWidth: 155,
            width: 'auto'
          }
        }), /*#__PURE__*/React.createElement(TextField, {
          id: "cvv",
          "data-private": "lipsum",
          errorText: _this3.generateErrorText('cvv'),
          hintText: "CVV*",
          floatingLabelText: "CVV*",
          value: _this3.state.cvv,
          onChange: _this3.handleCardFieldChange,
          style: {
            marginRight: 8,
            marginLeft: 8,
            flex: '1',
            minWidth: 155,
            maxWidth: '50%',
            width: 'auto'
          }
        })))), /*#__PURE__*/React.createElement(Dialog, {
          title: orgBillingConfig.billingMethod === 'affiliate' ? "Change ".concat(_this3.props.clientDetails.organization_name, " Product") : "".concat(!hasPlan ? '' : 'Edit ').concat(_this3.props.clientDetails.organization_name, " Plan Details"),
          autoScrollBodyContent: true,
          open: _this3.state.showPlanModal,
          onRequestClose: function onRequestClose() {
            _this3.setState({
              showPlanModal: !_this3.state.showPlanModal
            });
          },
          actions: orgBillingConfig.billingMethod === 'affiliate' ? affiliateModalActions : planModalActions,
          actionsContainerStyle: {
            padding: 12
          },
          titleStyle: {
            color: _this3.props.theme.colors.black2
          },
          contentStyle: {
            width: '95%',
            maxWidth: 950
          },
          bodyStyle: {
            minHeight: 400
          },
          overlayStyle: {
            backgroundColor: 'transparent'
          }
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, orgBillingConfig.billingMethod === 'affiliate' ? /*#__PURE__*/React.createElement(ChangeProduct, {
          orgBillingConfig: orgBillingConfig,
          partnerDetails: partnerDetails,
          clientDetails: clientDetails
        }) : /*#__PURE__*/React.createElement(EditPlan, {
          orgBillingConfig: orgBillingConfig,
          partnerDetails: partnerDetails,
          clientDetails: clientDetails,
          step: _this3.state.editPlanStep,
          cc: cc,
          gotoAddCardModal: function gotoAddCardModal() {
            _this3.setState({
              showPlanModal: false,
              showCCModal: true
            });
          }
        }))), /*#__PURE__*/React.createElement(Dialog, {
          title: "End ".concat(_this3.props.clientDetails.organization_name, " Subscription"),
          autoScrollBodyContent: true,
          open: _this3.state.showCancelModal,
          onRequestClose: function onRequestClose() {
            _this3.setState({
              showCancelModal: !_this3.state.showCancelModal
            });
          },
          actions: cancelModalActions,
          actionsContainerStyle: {
            padding: 12
          },
          titleStyle: {
            color: _this3.props.theme.colors.black2
          },
          overlayStyle: {
            backgroundColor: 'transparent'
          }
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, orgBillingConfig.billingMethod === 'license' ? /*#__PURE__*/React.createElement("div", {
          className: styles.cancelModalWrap
        }, /*#__PURE__*/React.createElement("h3", null, "Are you sure you want to cancel this client?"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, _this3.props.clientDetails.organization_name, " will be deactivated"), /*#__PURE__*/React.createElement("li", null, "Any future ad plans will not run"), /*#__PURE__*/React.createElement("li", null, "Any scheduled posts will not be posted"), /*#__PURE__*/React.createElement("li", null, "Subscribed content will not be posted"), hasPlan && /*#__PURE__*/React.createElement("li", null, "This client's monthly ad subscription will be canceled."))) : /*#__PURE__*/React.createElement("div", {
          className: styles.cancelModalWrap
        }, /*#__PURE__*/React.createElement("h3", null, "Are you sure you want to end this client's subscription?"), _this3.props.billingHistory && !!_this3.props.billingHistory.length && /*#__PURE__*/React.createElement("p", null, "The current billing cycle for", ' ', _this3.props.clientDetails.organization_name, " will end on ", _this3.props.paidThroughDate, "."), /*#__PURE__*/React.createElement("p", null, "After this date:"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, _this3.props.clientDetails.organization_name, " will be deactivated"), /*#__PURE__*/React.createElement("li", null, "Any future ad plans will not run"), /*#__PURE__*/React.createElement("li", null, "Any scheduled posts will not be posted"), /*#__PURE__*/React.createElement("li", null, "Subscribed content will not be posted"))))), /*#__PURE__*/React.createElement(Dialog, {
          title: 'Cancel Ads Plan',
          autoScrollBodyContent: true,
          open: _this3.state.showLicenseAdsCancelModal,
          onRequestClose: function onRequestClose() {
            _this3.setState({
              showLicenseAdsCancelModal: !_this3.state.showLicenseAdsCancelModal
            });
          },
          actions: cancelLicenseAdsModalActions,
          actionsContainerStyle: {
            padding: 12
          },
          titleStyle: {
            color: _this3.props.theme.colors.black2
          },
          overlayStyle: {
            backgroundColor: 'transparent'
          }
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.cancelModalWrap
        }, /*#__PURE__*/React.createElement("h3", null, "Are you sure you want to cancel this client's ads plan?"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, _this3.props.clientDetails.organization_name, " will remain active"), /*#__PURE__*/React.createElement("li", null, "Any unspent ad budget will remain available"), /*#__PURE__*/React.createElement("li", null, "Ad budget will no longer be automatically credited to this account"))))), /*#__PURE__*/React.createElement(Dialog, {
          title: "Add Advertising Funds",
          autoScrollBodyContent: true,
          open: _this3.state.showAddFundsModal,
          onRequestClose: function onRequestClose() {
            _this3.setState({
              showAddFundsModal: !_this3.state.showAddFundsModal
            });
          },
          actions: addFundsModalActions,
          actionsContainerStyle: {
            padding: 12
          },
          bodyStyle: {
            minHeight: 350
          },
          titleStyle: {
            color: _this3.props.theme.colors.black2
          },
          overlayStyle: {
            backgroundColor: 'transparent'
          }
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.contentLine,
          style: {
            marginTop: 24
          }
        }, "How much money do you want to add to this client's ad budget?"), "$", /*#__PURE__*/React.createElement(TextField, {
          hintText: "Amount",
          floatingLabelText: "Amount",
          style: {
            flex: 1,
            minWidth: 225
          },
          value: _this3.state.addFundsModalAmount,
          onChange: function onChange(e) {
            _this3.setState(_defineProperty({}, e.target.id, e.target.value));
          },
          id: "addFundsModalAmount"
        }))), _this3.props.contract && /*#__PURE__*/React.createElement(Dialog, {
          autoScrollBodyContent: true,
          open: _this3.state.showAgreementModal,
          onRequestClose: function onRequestClose() {
            _this3.setState({
              showAgreementModal: false
            });
          }
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AgreementPreview, {
          style: {
            boxShadow: 'none',
            margin: 0,
            padding: 0
          },
          isAffiliateClientContract: true,
          contract: _this3.props.contract
        })))));
      });
    }
  }]);

  return BillingDetail;
}(Component)) || _class);
export { BillingDetail as default };